<template>
    <div class="tile is-parent">
        <article class="tile is-child box">
            <p class="title">奖品名称</p>
            <div class="block">
                <input class="input width-2" v-model="params.title"/>
            </div>
            <p v-if="params.prizeId>0" class="title">类型: <span v-if="params.type==1" style="font-weight: bold">优惠劵</span><span v-if="params.type==2" style="font-weight: bold">其他</span></p>
            <div v-else>
                <p class="title">类型</p>
                <div class="block">
                    <el-select v-model="params.type" placeholder="请选择">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="block">
                <div v-if="params.type==1">
                    <div v-if="params.prizeId>0">
                        <p class="title" style="margin-top: 10px">优惠券ID:{{params.id}}</p>
                        <p class="title" style="margin-top: 10px">数量：{{params.count}}</p>
                    </div>
                    <div v-else>
                        <p class="title" style="margin-top: 10px">优惠券ID</p>
                        <input type="number" class="input width-2" v-model.number="params.id"/>
                    </div>
                </div>
                <div v-else>
                    <p class="title" style="margin-top: 10px">数量：</p>
                    <input type="number" class="input width-2" v-model.number="params.count"/>
                </div>
            </div>
            <p class="title">获奖图片</p>
            <el-upload
                    class="avatar-uploader"
                    :action="server"
                    :show-file-list="false"
                    name="image"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload">
                <div class="info"><el-button class="floatl" size="small" type="primary">点击上传</el-button><div  slot="tip" class="el-upload__tip floatl" style="color: red;font-size: 15px">只能上传jpg/png文件，且不超过500kb【建议宽高尺寸 600px * 764px】</div></div>
                <image-component :image="params.image" :width="300"></image-component>

            </el-upload>
            <p class="title">获奖推送文案</p>
            <p class="font">使用占位符: ( 用户名: $NAME , 奖品名: $PRIZE ）替代特殊内容</p>
            <div class="block" style="width:500px">
                <el-input
                        type="textarea"
                        :rows="5"
                        :autosize="{ minRows: 5 }"
                        placeholder="请输入内容"
                        v-model="params.noticeContent">
                </el-input>
            </div>
            <div class="block">
                <button class="button" @click="cancelEdit">取消</button>
                <button class="button is-info" @click="saveEdit" style="margin-left: 30px;">保存</button>
            </div>
        </article>
    </div>
</template>
<script type="text/babel">
export default {
  data () {
    return {
      params: {
        activityId: null,
        prizeId: 0,
        title: '',
        type: 1,
        id: 0,
        count: 0,
        noticeContent: '',
        image: {
          image: '',
          width: 0,
          height: 0
        }
      },
      prizeId: 0,
      options: [{
        value: 1,
        label: '优惠券'
      }, {
        value: 2,
        label: '其他'
      }]

    }
  },
  mounted: function () {
    this.$nextTick(function () {
      if (this.$route.query.prizeId) {
        this.prizeId = parseInt(this.$route.query.prizeId)
      }
      this.params.activityId = parseInt(this.$route.query.activityId)
      if (this.prizeId > 0) {
        this.getPrize()
      }
    })
  },
  computed: {
    server () {
      return process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage'
    }
  },
  methods: {
    handleAvatarSuccess (response, file) {
      this.params.image.image = response.data.images.info.path
      this.params.image.width = response.data.images.info.width
      this.params.image.height = response.data.images.info.height
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png'
      const isLt2M = file.size / 1024 < 500

      if (!isJPG) {
        this.$message('上传图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message('上传图片大小不能超过 500kb!')
      }
      return isJPG && isLt2M
    },

    // 获取专题分类详情
    getPrize () {
      HttpRequest.get('/admin.php?method=cartactivity.getPrize', {activityId: this.params.activityId, prizeId: this.prizeId}, true).then((response) => {
        this.params = response.data
      }, (response) => {
      })
    },
    // 保存编辑
    saveEdit () {
      let params = Object.assign({}, this.params)

      if (!params.title) {
        this.$message('请输入奖品名称')
        return
      }
      if (!params.image.image) {
        this.$message('请上传图片')
        return
      }
      console.log('234234', params)
      HttpRequest.post('/admin.php?method=cartactivity.doSavePrize', params, true).then((response) => {
        this.$message('保存成功', 1000)
        setTimeout(() => {
          this.$router.push({name: 'addCartPrizeConfig', query: {activityId: this.params.activityId}})
        })
      }, (response) => {

      })
    },
    cancelEdit () {
      this.$router.push({name: 'addCartPrizeConfig', query: {activityId: this.params.activityId}})
    }
  }
}
</script>
<style lang="less" scoped>

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    .info{
        height:35px;
        .floatl{
            float: left;
        }
    }
    .font{
        color:red;
        font-weight: bold;
    }
</style>
